function CurvedTitle(props){
  return (
    <div id="curvedtitle">
      <div id='circle'>
        <span className='curved-6 curved-hello'>
          <span>H</span>
          <span>e</span>
          <span>l</span>
          <span>l</span>
          <span>o</span>
          <span>,</span>
        </span>
        <span className='curved-2 curved-my'>
          <span>m</span>
          <span>y</span>
        </span>
        <span className='curved-4 curved-name'>
          <span>n</span>
          <span>a</span>
          <span>m</span>
          <span>e</span>
        </span>   
        <span className='curved-2 curved-is'>
          <span>i</span>
          <span>s</span>
        </span>
      </div>
    </div>
  )
}

export default CurvedTitle;